<script>
  import Dropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/Dropdown.svelte";
  import ListItem from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/ListItem.svelte";
  import { additionsStore, modulePricingApiStore } from "./stores";

  let { modules = [] } = $props();
  let close = $state(null);
  let addable = $derived(
    Object.keys($modulePricingApiStore?.modules || {}).filter(
      (m) => !(m in $additionsStore)
    )
  );
  let disabled = $derived(!addable.length);

  const handleAddLicense = (mod) => {
    $additionsStore[mod] = 1;
    if (close) close();
  };
</script>

<Dropdown
  kind="ghost-blue"
  leadingIcon="fa-regular fa-plus"
  {disabled}
  trailingIcon=""
  bind:close
  dynamicWidth={false}
  class={disabled ? "disabled" : ""}
>
  <span slot="button">Add License</span>
  {#each addable as licenseKind}
    {@const mod = modules.find((m) => m.kind === licenseKind) || {}}
    <ListItem onclick={() => handleAddLicense(licenseKind)}
      >{mod.title}</ListItem
    >
  {/each}
</Dropdown>
